import { ReactNode, useContext } from 'react';
import { createContext } from 'react';

export type CurrentPageIndex = string | null;

export const CurrentPageIndexContext = createContext<CurrentPageIndex>(null);

export function useCurrentPageIndexContext() {
  return useContext(CurrentPageIndexContext);
}

type CurrentPageIndexProviderProps = {
  children: ReactNode;
  pageIndex: CurrentPageIndex;
};

export function CurrentPageIndexProvider(props: CurrentPageIndexProviderProps) {
  const { children, pageIndex } = props;

  return <CurrentPageIndexContext.Provider value={pageIndex}>{children}</CurrentPageIndexContext.Provider>;
}
